import HeaderLinksRedux from "./header-links-redux";
export default HeaderLinksRedux;
